import { useStateContext } from '../../context/ContextProvider';
import Footer from '../../components/Footer/Footer';
import ImageCarousel from '../../components/ImageSlider/ImageCarousel';
import { PiCheckCircleDuotone } from 'react-icons/pi';
import OtpFormLP2 from '../../components/LeadForm/OtpFormLP2';
import ColorCountdown from '../../components/Countdown/ColorCountdown';
import ColorLeadForm from '../../components/LeadForm/ColorLeadForm';
import ColorImageCarousel from '../../components/ImageSlider/ColorImageCarousel';
import { bgMap, borderMap, lightBgMap, neonMap, textMap, vectorMap } from '../../components/ColorMappingOptions';
import ColorEventForm from '../../components/LeadForm/ColorEventForm';


function ColorEventPage({
    color = "orange",
    snapchat = false,
    language,
    poster,
    video,
    images,
    heading,
    heading2 = null,
    heading3 = null,
    gridDetails = null,
    confDetails = null,
    datesDetails = null,
    // amenities
    base_url,
    developer,
    project,
    leadType = "Apartment",
    enquiries = ["Studio", "1 Bedroom", "2 Bedrooms", "3 Bedrooms"],
    cities = null,
    assignedToManager = null,
    assignedToSales = null,
    contactTime = false,
    otpCode = null,
}) {
    const amenities = [
        {
            "icon": "/assets/images/icons/pool.svg",
            "en_text": "Swimming Pool",
            "ar_text": "مسبح بانورامي",
        },
        {
            "icon": "/assets/images/icons/gym.svg",
            "en_text": "Fully Equipped Gym",
            "ar_text": "نادي صحي مجهز",
        },
        {
            "icon": "/assets/images/icons/restaurant.svg",
            "en_text": "Restaurants & Cafés",
            "ar_text": "كافيهات ومطاعم راقية",
        },
        {
            "icon": "/assets/images/icons/greenary.svg",
            "en_text": "Gardens & Green Spaces",
            "ar_text": "حدائق ومساحات خضراء",
        },
        {
            "icon": "/assets/images/icons/parking.svg",
            "en_text": "Covered Parking",
            "ar_text": "مواقف سيارات مغطاة",
        },
        {
            "icon": "/assets/images/icons/security.svg",
            "en_text": "24/7 Security",
            "ar_text": "أمن وحراسة على مدار الساعة",
        }
    ];

    const {
        langs,
        langCode,
        t
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    return (
        <>
            <div className={`w-[100vw] bg-[#00112D] flex flex-col items-center justify-between w-full gap-6 md:gap-12 min-h-screen !pt-4 !pb-12`}>
                {/* LOGO */}
                <div className="padding-container w-full flex justify-end">
                    <img
                        src="/assets/images/logo/libya-logo.svg"
                        alt="DODEAL PROPERTIES"
                        className="h-[50px] w-auto self-end"
                    />
                </div>
                <div className="padding-container w-full flex flex-col gap-6">
                    {/* HEADING AND COUNTER */}
                    <div className="flex flex-col gap-5">
                        {/* HEADING */}
                        {heading}
                    </div>

                    {/* IMAGE AND FORM */}
                    <div id="form-container-div" className="w-full flex items-center justify-center">
                        {/* HERO IMAGE */}
                        {/* <div className="relative flex items-center justify-center">
                            <div className="absolute top-4 left-1/2 -translate-x-1/2 z-[1]">
                                <ColorCountdown color={color} />
                            </div>
                            {video ? (
                                <video
                                    autoPlay={true}
                                    loop={true}
                                    muted={true}
                                    playsInline={true}
                                    preload="auto"
                                    poster={poster}
                                    width="230"
                                    height="230"
                                    className={`relative rounded-2xl min-w-[230px] min-h-[230px] w-[80%] h-auto max-w-[400px] max-h-[400px] aspect-square`}
                                >
                                    <source src={video} type="video/mp4" />
                                </video>
                            ) : (
                                <img
                                    rel="preload"
                                    src={poster}
                                    alt={`DODEAL PROPERTIES`}
                                    className="relative rounded-2xl min-w-[230px] min-h-[230px] w-[80%] h-auto max-w-[400px] max-h-[400px] aspect-square"
                                />
                            )}
                            <div className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-2xl min-w-[230px] min-h-[230px] w-[80%] h-auto max-w-[400px] max-h-[400px] aspect-square border ${borderMap[color]} bg-black z-[-1] rotate-[-7deg]`}></div>
                        </div> */}

                        {/* FORM */}
                        {otpCode == 101 ? (
                            <ColorEventForm
                                color={color}
                                base_url={base_url}
                                developer={developer}
                                project={project}
                                leadType={leadType}
                                language={language}
                                // enquiries={enquiries}
                                cities={cities}
                                assignedToManager={assignedToManager}
                                assignedToSales={assignedToSales}
                                askEmail={true}
                                contactTime={contactTime}
                            />
                        ) : (
                            <ColorEventForm
                                color={color}
                                base_url={base_url}
                                developer={developer}
                                project={project}
                                leadType={leadType}
                                language={language}
                                // enquiries={enquiries}
                                cities={cities}
                                assignedToManager={assignedToManager}
                                assignedToSales={assignedToSales}
                                contactTime={contactTime}
                                askEmail={true}
                                otpCode={otpCode}
                            />
                        )}
                    </div>
                </div>

                <div className="relative w-full -mt-5 -mb-10">
                    <img
                        src={images[0]}
                        alt={`DODEAL LIBYA EVENT`}
                        className={`object-cover w-[100vw] h-auto -z-1`}
                        style={{ zIndex: 0 }}
                    />
                </div>
                <div className="w-[100vw] relative -mt-[15vw] md:-mt-[20vw] lg:-mt-[15vw] flex flex-col gap-6">
                    {/* AFTER IMAGE */}
                    <div className="relative w-[100vw] h-full flex items-center justify-center"
                        style={{
                            zIndex: 2,
                            backgroundImage: `url('/assets/images/projects/event/libya/blur.svg')`,
                            backgroundRepeat: 'repeat-x',        // ← repeats only horizontally
                            backgroundSize: 'contain',           // ← full image visible, no cropping
                            backgroundPosition: 'top center',    // ← aligns to top
                        }}
                    >
                        <div className="w-[100vw] relative flex flex-col gap-6 padding-container !py-12 text-center items-center justify-center z-1" style={{ zIndex: 1 }}>
                            {heading2 ? (
                                <div className="w-full flex flex-col gap-4">
                                    {heading2}
                                    <div className="flex items-center justify-center w-full gap-4">
                                        <a
                                            href="#form-container-div"
                                            className={`custom-btn w-fit min-w-[120px] font-medium border border-1 ${color == "gold" ? "primary-bg" : bgMap[color]} text-white ${color == "gold" ? "border-[var(--primary)]" : borderMap[color]}`}
                                        >
                                            {t("about_project")}
                                        </a>
                                        <a
                                            href="#form-container-div"
                                            className={`custom-btn-trans w-fit min-w-[120px] font-medium ${lightBgMap[color]} border border-1 ${color == "gold" ? "border-[var(--primary)]" : borderMap[color]} ${textMap[color]}`}
                                        >
                                            {t("register_now")}
                                        </a>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="relative w-full">
                        <div
                            className="absolute w-full h-full flex items-start justify-center top-[-15vw] md:top-[-20vw] lg:top-[-15vw] left-0 z-0"
                            style={{ zIndex: 0 }}
                        >
                            <img
                                src={"/assets/images/projects/event/libya/city-bg.svg"}
                                alt={`DODEAL LIBYA EVENT`}
                                className="w-[200vw] h-[200vw] md:w-[120vw] md:h-[120vw] lg:w-[100vw] lg:h-[100vw] object-cover select-none"
                                style={{
                                    opacity: 0.1,
                                    transform: "rotate(0deg)",
                                    mixBlendMode: "luminosity",
                                }}
                            />
                        </div>
                        {/* GRID DETAILS */}
                        {gridDetails ? (
                            <div className="w-[100vw] relative flex flex-col gap-6 padding-container !py-6">
                                <div className="relative w-full grid grid-cols-1 md:grid-cols-3 gap-6">
                                    {gridDetails.map((grid, index) => (
                                        <>
                                            <div key={index} className="custom-card px-6 py-8 w-full relative flex text-center items-center justify-center capitalize">
                                                <div className="absolute w-full top-0 left-0 h-fit -translate-y-1/2 flex items-center justify-center">
                                                    <img
                                                        src={grid.icon}
                                                        alt="LIBYA EVENT"
                                                        className="w-[50px] aspect-square rounded-full"
                                                    />
                                                </div>
                                                <div className={`font-semibold text-base lg:text-lg`}>
                                                    {grid.topic}
                                                </div>
                                            </div>
                                        </>
                                    ))}
                                </div>
                            </div>
                        ) : null}
                        {/* HEADING 3 */}
                        {heading3 ? (
                            <div className="w-[100vw] relative flex flex-col gap-6 padding-container !py-6 text-center items-center justify-center z-1">
                                <div className="w-full flex flex-col gap-4">
                                    {heading3}
                                    <div className="flex items-center justify-center w-full gap-4">
                                        <a
                                            href="#form-container-div"
                                            className={`custom-btn w-fit min-w-[120px] font-medium border border-1 ${color == "gold" ? "primary-bg" : bgMap[color]} text-white ${color == "gold" ? "border-[var(--primary)]" : borderMap[color]}`}
                                        >
                                            {t("register_now")}
                                        </a>
                                        <a
                                            href="#form-container-div"
                                            className={`custom-btn-trans w-fit min-w-[120px] font-medium ${lightBgMap[color]} border border-1 ${color == "gold" ? "border-[var(--primary)]" : borderMap[color]} ${textMap[color]}`}
                                        >
                                            {t("about_project")}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {/* DEVELOPER */}
                        <div className="w-[100vw] relative flex flex-col gap-6 padding-container !py-6 text-center items-center justify-center">
                            {language == "Arabic" ? (
                                <h1 className="text-center text-xl lg:text-2xl font-bold gap-1 flex flex-wrap items-center justify-center">
                                    بالتعاون مع أقوى
                                    <span className={`${color == "gold" ? "primary-text" : textMap[color]} ${color == "gold" ? "" : neonMap[color]}`}>
                                        مطوري دبي
                                    </span>
                                </h1>
                            ) : (
                                <h1 className="text-center text-xl lg:text-2xl font-bold gap-1 flex flex-wrap items-center justify-center capitalize">
                                    In collaboation with
                                    <span className={`${color == "gold" ? "primary-text" : textMap[color]} ${color == "gold" ? "" : neonMap[color]}`}>
                                        Dubai's top developers
                                    </span>
                                </h1>
                            )}
                            <div className="flex flex-wrap gap-y-8 gap-x-10 w-full items-center justify-center text-center">
                                <img
                                    src="/assets/images/projects/event/libya/binghatti-logo.svg"
                                    alt="TOP DEVELOPERS DUBAI DODEAL LIBYA EVENT"
                                    className="w-[120px] h-auto object-contain object-center"
                                />
                                <img
                                    src="/assets/images/projects/event/libya/azizi-logo.svg"
                                    alt="TOP DEVELOPERS DUBAI DODEAL LIBYA EVENT"
                                    className="w-[120px] h-auto object-contain object-center"
                                />
                                <img
                                    src="/assets/images/projects/event/libya/damac-logo.svg"
                                    alt="TOP DEVELOPERS DUBAI DODEAL LIBYA EVENT"
                                    className="w-[120px] h-auto object-contain object-center"
                                />
                                <img
                                    src="/assets/images/projects/event/libya/samana-logo.svg"
                                    alt="TOP DEVELOPERS DUBAI DODEAL LIBYA EVENT"
                                    className="w-[120px] h-auto object-contain object-center"
                                />
                            </div>
                        </div>
                        {/* HIKAL */}
                        <div className="w-[100vw] relative flex flex-col gap-6 padding-container !py-6 text-center items-center justify-center">
                            <div className="flex flex-col gap-4 w-full items-center justify-center text-center">
                                {language == "Arabic" ? (
                                    <h1 className="text-center text-2xl lg:text-3xl font-bold gap-1 flex flex-wrap items-center justify-center">
                                        برعاية
                                    </h1>
                                ) : (
                                    <h1 className="text-center text-2xl lg:text-3xl font-bold gap-1 flex flex-wrap items-center justify-center capitalize">
                                        Sponsored by
                                    </h1>
                                )}
                                <img
                                    src="/assets/images/projects/event/libya/hikal-logo.svg"
                                    alt="TOP DEVELOPERS DUBAI DODEAL LIBYA EVENT"
                                    className="w-[70px] h-auto object-contain object-center"
                                />
                            </div>
                        </div>
                        {/* CONF DETAILS  */}
                        {confDetails ? (
                            <div className="w-[100vw] relative flex flex-col gap-6 padding-container !py-6 text-center items-center justify-center">
                                <div className="flex flex-col gap-4 w-full items-center justify-center text-center">
                                    {language == "Arabic" ? (
                                        <h1 className="text-center text-xl lg:text-2xl font-bold gap-1 flex flex-wrap items-center justify-center">
                                            برنامج
                                            <span className={`${color == "gold" ? "primary-text" : textMap[color]} ${color == "gold" ? "" : neonMap[color]}`}>
                                                المؤتمر
                                            </span>
                                        </h1>
                                    ) : (
                                        <h1 className="text-center text-xl lg:text-2xl font-bold gap-1 flex flex-wrap items-center justify-center capitalize">
                                            Conference
                                            <span className={`${color == "gold" ? "primary-text" : textMap[color]} ${color == "gold" ? "" : neonMap[color]}`}>
                                                Program
                                            </span>
                                        </h1>
                                    )}
                                    <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-4">
                                        {confDetails.map((item, index) => (
                                            <div
                                                key={index}
                                                className="w-full h-full relative custom-card p-4 flex flex-col gap-2 items-center justify-center text-start"
                                            >
                                                <h1 className={`text-center text-lg lg:text-xl gap-1 flex flex-wrap items-center justify-center capitalize ${color == "gold" ? "primary-text" : textMap[color]} ${color == "gold" ? "" : neonMap[color]}`}>
                                                    {item.heading}
                                                </h1>
                                                {item.points.map((point, pIndex) => (
                                                    <div className="w-full text-start grid grid-cols-8 gap-1">
                                                        <div className="w-full flex justify-center">
                                                            <img
                                                                src="/assets/images/projects/event/libya/tick.png"
                                                                alt="TOP DEVELOPERS DUBAI DODEAL LIBYA EVENT"
                                                                className="w-[20px] h-auto object-contain object-center"
                                                            />
                                                        </div>
                                                        <div className="col-span-7">
                                                            {point}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                    <div className="flex items-center justify-center w-full gap-4">
                                        <a
                                            href="#form-container-div"
                                            className={`custom-btn w-fit min-w-[160px] font-medium border border-1 ${color == "gold" ? "primary-bg" : bgMap[color]} text-white ${color == "gold" ? "border-[var(--primary)]" : borderMap[color]}`}
                                        >
                                            {t("register_now")}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {/* CITIES */}
                        <div className="relative flex padding-container !py-6 text-center items-center justify-center">
                            <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6">
                                {datesDetails.map((item, index) => (
                                    <div
                                        key={index}
                                        className="w-full h-full relative custom-card p-4 flex flex-col gap-4 items-center justify-center text-start"
                                    >
                                        <h1 className={`text-center text-lg lg:text-xl gap-1 flex flex-wrap items-center justify-center capitalize`}>
                                            {item.city}
                                        </h1>
                                        <div className="w-full grid grid-cols-2 gap-4 w-full">
                                            <div className="w-full text-start grid grid-cols-6 gap-1">
                                                <div className="w-full h-full flex justify-center items-center">
                                                    <img
                                                        src="/assets/images/projects/event/libya/event-date.svg"
                                                        alt="TOP DEVELOPERS DUBAI DODEAL LIBYA EVENT"
                                                        className="w-[15px] h-[15px] object-contain object-center"
                                                    />
                                                </div>
                                                <div className="col-span-5 flex items-center">
                                                    {item.date}
                                                </div>
                                            </div>
                                            <div className="w-full text-start grid grid-cols-6 gap-1">
                                                <div className="w-full h-full flex justify-center items-center">
                                                    <img
                                                        src="/assets/images/projects/event/libya/event-venue.svg"
                                                        alt="TOP DEVELOPERS DUBAI DODEAL LIBYA EVENT"
                                                        className="w-[15px] h-[15px] object-contain object-center"
                                                    />
                                                </div>
                                                <div className="col-span-5">
                                                    {item.venue}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        </>
    );
}

export default ColorEventPage;
